export enum ReportName {
    /** 0 */
    UNKNOWN_REPORT = 'UNKNOWN_REPORT',
    /** 1 */
    WORKING_CAPITAL_LIFT = 'WORKING_CAPITAL_LIFT',
    /** 2 */
    WORKING_CAPITAL_LIFT_INSIGHTS = 'WORKING_CAPITAL_LIFT_INSIGHTS',
    /** 3 */
    SPEND_VOLUME = 'SPEND_VOLUME',
    /** 4 */
    SUPPLIER_ENROLLMENT = 'SUPPLIER_ENROLLMENT',
    /** 5 */
    DAYS_PAYABLE_OUTSTANDING = 'DAYS_PAYABLE_OUTSTANDING',
    /** 6 */
    EARLY_PAY_ADOPTION = 'EARLY_PAY_ADOPTION',
    /** 7 */
    AGING_FORECAST = 'AGING_FORECAST',
    /** 8 */
    SPEND_VOLUME_LANDING = 'SPEND_VOLUME_LANDING'
}
